import { Reducer } from "redux";

import { NotificationListResponse } from "../models/api/Admin";
import { NotificationListActionDispatchTypes } from "../constants/User";
import { NotificationListDispatchTypes } from "../models/dispatchTypes/Master";

const initialState: NotificationListResponse = {
  loading: false,
  response: {
    searchResponse: [],
    totalRows: 0,
  },
  error: null,
}
const PostNotificationListReducer: Reducer<
NotificationListResponse,
NotificationListDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case NotificationListActionDispatchTypes.NOTIFICATION_LIST_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case NotificationListActionDispatchTypes.NOTIFICATION_LIST_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case NotificationListActionDispatchTypes.NOTIFICATION_LIST_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case NotificationListActionDispatchTypes.NOTIFICATION_LIST_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PostNotificationListReducer;
